module.exports = __webpack_public_path__ + "static/media/traffic-light-stop.f4180163.svg";